import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "./index.css";
import App from "./App.js";

const PUBLISHABLE_KEY = import.meta.env["VITE_CLERK_PUBLISHABLE_KEY"] as string | undefined;

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

// When no Clerk key is configured, render the app without auth (dev mode / offline)
const root = createRoot(rootEl);

if (PUBLISHABLE_KEY) {
  root.render(
    <StrictMode>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <App />
      </ClerkProvider>
    </StrictMode>,
  );
} else {
  // No Clerk key — run in unauthenticated dev mode
  console.warn("[auth] VITE_CLERK_PUBLISHABLE_KEY not set — running without authentication");
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
